import React from "react";
import Popover from "../../../../../components/popover/Popover";

export default function TicketCreateHelp({ buttonClassName }: {buttonClassName?: string}) {
    return (
        <Popover buttonClassName={buttonClassName} title="Create Ticket Message Template" size="md">
            <div>
                <p>
                    When a ticket is created, from a channel menu, hovering over a Slack message or
                    in any other way in which creates a thread, this setting allows you to customize
                    what that text will display. By default, if nothing is specified, the following message
                    be used:
                </p>
                <blockquote className="alert alert-light">
                    <em>
                        New request created:
                        {" "}
                        &#123;&#123;SUBJECT&#125;&#125;
                        <br />
                        <br />
                        &#123;&#123;DESCRIPTION&#125;&#125;
                        <br />
                        Created By: &#123;&#123;CREATOR&#125;&#125;
                    </em>
                </blockquote>

                <p>
                    <h5>Variables</h5>
                    To make the message more helpful, you can use variables which will be replaced
                    with the associated values at the time the ticket is created. In the above example,
                    <code>&#123;&#123;SUBJECT&#125;&#125;</code>
                    {" "}
                    and
                    {" "}
                    <code>&#123;&#123;DESCRIPTION&#125;&#125;</code>
                    are variables which will be replaced with the subject and description of the tiket respectively.
                    You can use the following variables in your template
                </p>
                <ul>
                    <li>
                        <code>&#123;&#123;SUBJECT&#125;&#125;</code>
                        {" "}
                        - The subject of the ticket.
                    </li>
                    <li>
                        <code>&#123;&#123;DESCRIPTION&#125;&#125;</code>
                        {" "}
                        - The description of the ticket.
                    </li>
                    <li>
                        <code>&#123;&#123;DESCRIPTION_OR_SUBJECT&#125;&#125;</code>
                        {" "}
                        - The description, but if the description does not exist, will instead use the subject.
                    </li>
                    <li>
                        <code>&#123;&#123;TICKET_NUMBER&#125;&#125;</code>
                        {" "}
                        - The Foqal Agent ticket number.
                    </li>
                    <li>
                        <code>&#123;&#123;PRIORITY&#125;&#125;</code>
                        {" "}
                        - The priority of the ticket.
                    </li>
                    <li>
                        <code>&#123;&#123;STATUS&#125;&#125;</code>
                        {" "}
                        - The status of the ticket.
                    </li>
                    <li>
                        <code>&#123;&#123;CREATOR&#125;&#125;</code>
                        {" "}
                        - The creator name and Slack link. This will often be automatically inserted at
                        the end of the template.
                    </li>
                    <li>
                        <code>&#123;&#123;REQUESTOR&#125;&#125;</code>
                        {" "}
                        - The requester name and Slack link. This will often be automatically inserted at
                        the end of the template.
                    </li>

                </ul>
            </div>
        </Popover>
    );
}

TicketCreateHelp.defaultProps = {
    buttonClassName: "",
};
